import { isDynamicLegislativeItemWorkflowAssignmentType } from '@govinity/shared-config';
import { z } from 'zod';
import { DocumentTypeSignatureRules } from './signature-rules.js';
import { stepAssignmentSchema } from '../legislative-item-workflows/index.js';
import { SecurityLevel } from '../shared/index.js';
export { DocumentTypeSignatureRules } from './signature-rules.js';
// Titles are plain names: they are printed on the document and identify each signer's fields.
const SIGNER_TITLE = /^[\w\- ]+$/;
export const documentTypeSignerSchema = z.object({
    title: z
        .string()
        .trim()
        .min(1, 'Title is required')
        .max(50)
        .regex(SIGNER_TITLE, 'Title may only contain letters, numbers, spaces, - and _'),
    assignment: stepAssignmentSchema,
});
const isDistinct = (values) => new Set(values).size === values.length;
// Creator and staff contact name the same people whatever id they carry.
const assignmentKey = ({ id, type }) => isDynamicLegislativeItemWorkflowAssignmentType(type) ? type : `${type}:${id}`;
export const documentTypeSignersSchema = z
    .array(documentTypeSignerSchema)
    .refine((signers) => isDistinct(signers.map(({ title }) => title.toLowerCase())), 'Each signer needs a different title')
    .refine((signers) => isDistinct(signers.map(({ assignment }) => assignmentKey(assignment))), 'Each signer needs to be a different person or position');
export const documentTypeCreateSchema = z
    .object({
    name: z.string().min(1, 'Name is required').max(255),
    filename: z.string().max(255).nullable(),
    code: z.string().min(1, 'Code is required').max(255),
    description: z.string().min(1, 'Description is required').nullable(),
    isActive: z.boolean(),
    isPublic: z.boolean(),
    securityLevel: z.enum(SecurityLevel),
    includeInAttachmentsList: z.boolean(),
    autoNumberingConfigId: z.number().optional().nullable(),
    requiresSignature: z.boolean().optional(),
    signers: documentTypeSignersSchema.optional(),
    signInOrder: z.boolean().optional(),
})
    .refine((documentType) => !new DocumentTypeSignatureRules(documentType).isMissingSigners(), {
    message: 'Add at least one signer',
    path: ['signers'],
});
export const documentTypeUpdateSchema = documentTypeCreateSchema;
export const documentTypeSaveDocumentSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    filename: z.string().min(1, 'Filename is required').max(255),
});
